import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, ArrowRight, CreditCard } from "lucide-react";
import api from "@/lib/api";

const PAY_STYLE = {
  paid: "badge-complete",
  complete: "badge-complete",
  pending: "badge-pending",
  unpaid: "badge-pending",
  failed: "badge-failed",
  expired: "badge-failed",
};

export default function BillingHistory() {
  const [txns, setTxns] = useState(null);

  useEffect(() => {
    api.get("/billing/transactions").then(({ data }) => setTxns(data)).catch(() => setTxns([]));
  }, []);

  return (
    <div className="card-mtr" data-testid="billing-history">
      <h2 className="font-bold text-navy text-[18px] flex items-center gap-2 mb-1">
        <Receipt size={20} className="text-mortar" /> Billing &amp; receipts
      </h2>
      <p className="text-mortar text-[14px] mb-4">
        Every order you've placed. Cards are securely handled by Stripe at checkout — returning
        customers can reuse a saved card via Stripe's secure payment page.
      </p>

      {txns === null ? (
        <div className="space-y-2">{[0, 1].map((i) => <div key={i} className="h-14 skeleton rounded-input" />)}</div>
      ) : txns.length === 0 ? (
        <div className="text-center py-6" data-testid="billing-empty">
          <CreditCard className="text-mortar mx-auto mb-2" size={24} />
          <p className="text-iron font-semibold text-[15px]">No transactions yet</p>
          <p className="text-mortar text-[13px] mt-1">Receipts will appear here after your first order.</p>
        </div>
      ) : (
        <div className="divide-y divide-gravel" data-testid="billing-list">
          {txns.map((t) => (
            <div key={t.session_id} className="py-3 flex items-center justify-between gap-3 flex-wrap" data-testid={`billing-row-${t.session_id}`}>
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-iron text-[14px] truncate">{t.address || "Roof report"}</p>
                <p className="text-[12px] text-mortar mt-0.5">{new Date(t.created_at).toLocaleString()} · {t.product_name || "Premium Residential"}</p>
              </div>
              <span className="metric text-iron text-[16px]">${Number(t.amount).toFixed(2)}</span>
              <span className={PAY_STYLE[t.payment_status] || "badge-pending"}>
                <span className="w-1.5 h-1.5 rounded-full bg-current" />
                {t.payment_status === "paid" ? "Paid" : t.payment_status === "pending" ? "Pending" : t.payment_status}
              </span>
              {t.report_id && (
                <Link to={`/reports/${t.report_id}`} className="text-orange font-semibold text-[13px] flex items-center gap-1" data-testid={`billing-view-${t.report_id}`}>
                  View <ArrowRight size={14} />
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
